export default function FastSelectBox(options){
    let container = options.container
    let station = options.station

    let container_element, input_element, label_element

    this.generate = () =>{
        generateContainer()
        generateInput()
        generateLabel()

        $(container_element).append(label_element,input_element)

        $(container).html(container_element)

        eventsHandler()
    }

    function generateLabel(){
        label_element = document.createElement('label')
        label_element.innerText = "Seleção rápida"

        let element = document.createElement('span')
        $(element).addClass('ml-2 fas fa-question-circle')
        tippy(element, {
            content: 'Separadores: <span class="text-danger">,</span> ou <span class="text-danger">;</span> ou <span class="text-danger">|</span> <br> Exemplo: 4C-001;527;4E-027',
            allowHTML: true
        });
        $(label_element).append(element)
    }

    function generateContainer(){
        container_element = document.createElement('div')
        container_element.classList.add('fast-select-box-container')
    }

    function generateInput(){
        input_element = document.createElement('textarea')
        input_element.classList.add('form-control')
        input_element.classList.add('input-prefixes')
        input_element.placeholder = 'Lista de prefixos'
    }

    function eventsHandler(){
        $(input_element).on('keypress',function(e){
            if(e.originalEvent.code == "Enter" || e.originalEvent.code == "NumpadEnter"){
                prepareStations(this.value)
                event.preventDefault();
            }
        })
    }

    function prepareStations(complete_text){
        let identify_separator = (complete_text) =>{

        }
        let split = (complete_text) =>{
            let s = complete_text.split(";")
            let c = complete_text.split(",")
            let sp = complete_text.split(" ")
            let d = complete_text.split(".")
            let st = complete_text.split("|")
            let teste = _.maxBy([s,c,sp,d,st], function(item){
                return item.length
            })
            return teste
        }
        let splited = split(complete_text)

        station.list.forEach(station_prefix =>{
            if(splited.includes(station_prefix.prefix)){
                station_prefix.selected = true
            }
        })


    }
}